import { useQuery } from '@tanstack/react-query'

import { fetchClosures } from '@/lib/venue/closureApi'
import type { VenueClosureListView } from '@/lib/venue/closureTypes'

/** 목록·쓰기 2EP 가 공유하는 쿼리 키 — 단건 조회 EP 가 없어 이 캐시가 유일한 원천이다(`useCourts.ts` 승계). */
export function venueClosuresQueryKey(venueId: string) {
  return ['venue', venueId, 'closures'] as const
}

export function useVenueClosures(venueId: string) {
  return useQuery<VenueClosureListView>({
    queryKey: venueClosuresQueryKey(venueId),
    queryFn: () => fetchClosures(venueId),
  })
}
